import { useEffect, useState } from "react";
import { fetchApprovalData, sendApprovalRequest, sendPayRequest } from "../Api/ExpenseApproval";
import { Container, Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import { useAuth } from "../Context/AuthContext";

const ExpenseApproval = () => {
  const [approvals, setApprovals] = useState([]);
  const{user}=useAuth();
  useEffect(() => {
    const loadApprovals = async () => {
      try {
        const data = await fetchApprovalData(user?.organisationId);
        setApprovals(data.data || []);
      } catch (error) {
        toast.error("🦄 Error Fetching Approval Data");
      }
    };
    loadApprovals();
  }, []);

  const handleApprove = async (expenseId) => {
    try {
      await sendApprovalRequest(expenseId);
      toast.success(`🟢 Expense ${expenseId} Approved!`);
      setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      toast.error("❌ Error Sending Approval Request");
    }
  };

  const handlePay= async (expenseId) => {
   try {
      await sendPayRequest(expenseId);
      toast.success(`🟢 Paid Expense ${expenseId} `);
      setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      toast.error("❌ Error Sending Approval Request");
    }
  };

  return (
      <div className="main-content expand">
        <Container fluid className="list-container">
          <span className="list-title">Expense Approval</span>

          {approvals.length > 0 ? (
            <div className="table-wrapper">
              <div className="table-scroll-container">
                <Table bordered hover className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Expense Type</th>
                      <th>Employee Name</th>
                      <th>Employee ID</th>
                      <th>Merchant</th>
                      <th>Date</th>
                      <th>Amount</th>
                      <th>Currency</th>
                      <th>Payment Method</th>
                      <th>Description</th>
                      <th>Project Id</th>
                      <th>Status</th>
                      <th>Paid Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {approvals.map((approval, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{approval?.expenses?.expenseType}</td>
                        <td>{approval?.user?.name}</td>
                        <td>{approval?.user?.resourceId}</td>
                        <td>{approval?.expenses?.merchantName}</td>
                        <td>{new Date(approval?.expenses?.dateofExpense).toLocaleDateString()}</td>
                        <td>{approval?.expenses?.amountSpent}</td>
                        <td>{approval?.expenses?.currency}</td>
                        <td>{approval?.expenses?.paymentMethod}</td>
                        <td>{approval?.expenses?.descriptionNotes}</td>
                     <td> {approval?.project} - {approval?.expenses?.projectId}</td>
                        <td className={approval?.expenses?.approvalStatus === "W" ? "status-waiting" : "status-approved"}>
                          {approval?.expenses?.approvalStatus === "W" ? "Waiting" : "Approved"}
                        </td>
                           <td>{approval?.expenses?.paidStatus===true?"Paid":"Not Paid"}</td>
                        <td>
                          {approval?.expenses?.approvalStatus === "W" && (
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={() => handleApprove(approval?.expenses?.expenseId)}
                              className="approve-btn"
                               style={{marginLeft:"5px"}}
                            >
                              Approve
                            </Button>
                          )}
                            {approval?.expenses?.paidStatus ===false && (
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={() => handlePay(approval?.expenses?.expenseId)}
                              className="approve-btn"
                              style={{marginTop:"5px",marginLeft:"5px"}}
                            >
                              Pay
                            </Button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <p className="no-data">No approval requests found.</p>
          )}
        </Container>
      </div>
  );
};

export default ExpenseApproval;
